export default __webpack_public_path__ + "static/media/etapa5.e6afb4d3.png";